import React, { useRef } from 'react'
import { image } from '../../../../utils/data/baseUrl'
import { safeHTML } from '../../../../utils/safeHTML'
import Icon from '../../../baseComponents/gui/icon/Icon'
import { useCustomizationShowAnimation } from '../customizationFilters/customizationFiltersShowAnimation'
import { useOpen } from '../../../../hooks/useOpen'
import { useTranslation } from '../../../../translations'
import { gtmFunctions } from '../../../../constants/analytics/GTM'

const CustomizationBanner = React.forwardRef(function CustomizationBanner({}, ref) {
  const itemRef = useRef(null)
  const titleRef = useRef(null)
  const { t } = useTranslation()

  useCustomizationShowAnimation({
    index: 0,
    itemRef: itemRef,
    bannerTitleRef: titleRef,
  })

  const openLink = useOpen()
  const onBannerClick = () => {
    openLink('/kiosk')
    gtmFunctions.GTMCustomizationBanner()
  }

  return (
    <div
      ref={itemRef}
      className={'customization__banner'}
      onClick={onBannerClick}
    >
      <picture>
        <source
          srcSet={image('customization/banner/mobile.jpg')}
          media='(max-width: 767px)'
        />
        <source
          srcSet={image('customization/banner/tablet.jpg')}
          media='(min-width: 768px) and (max-width: 1279px)'
        />
        <source
          srcSet={image('customization/banner/laptop.jpg')}
          media='(min-width: 1280px) and (max-width: 1919px)'
        />
        <source
          srcSet={image('customization/banner/desktop.jpg')}
          media='(min-width: 1920px)'
        />
        <img
          className='customization__banner-image'
          src={image('customization/banner/mobile.jpg')}
          alt='kiosk banner'
        />
      </picture>

      <div
        className={'customization__banner-text'}
        ref={titleRef}
      >
        <h3>{safeHTML(t('customization.tasks.title'))}</h3>
        <span>{safeHTML(t('customization.tasks.text'))}</span>
      </div>

      <Icon
        className={'customization__banner-icon'}
        name={'customization/arrow'}
      />
    </div>
  )
})
export default CustomizationBanner
CustomizationBanner.propTypes = {}
